document.addEventListener("DOMContentLoaded", () => {
    // Locate the form and its associated table
    const container = document.querySelector("form#estimation-rejection-form")
    if (!container) return

    const decisionInputWrapper = container.querySelector("li[id*=decision_input]")
    const rejectionReasonInputWrapper = container.querySelector("li[id*=rejection_reason_input]")
    const RejectionNotesInputWrapper = container.querySelector("li[id*=rejection_notes_input]")

    // --- Constants ---
    const HIDDEN = "hidden"
    const DECISION_REJECTION = "rejected"
    const REJECTION_REASON_OTHER = "other"
    const DECISION_CHECKED = 'input[name$="[decision]"]:checked'
    const REJECTION_REASON_CHECKED = 'input[name$="[rejection_reason]"]:checked'

    const toggleRejectionReasonVisibility = () => {
        const selectedDecision = decisionInputWrapper?.querySelector(DECISION_CHECKED)
        const rejectionReasonInputs = rejectionReasonInputWrapper.querySelectorAll("input")
        if (decisionInputWrapper && (!selectedDecision || selectedDecision.value !== DECISION_REJECTION)) {
            rejectionReasonInputWrapper.classList.add(HIDDEN)
            rejectionReasonInputs.forEach(input => input.disabled = true)

            const selectedRejectionReason = rejectionReasonInputWrapper.querySelector(REJECTION_REASON_CHECKED)
            if (selectedRejectionReason) selectedRejectionReason.checked = false
        } else {
            rejectionReasonInputs.forEach(input => input.disabled = false)
            rejectionReasonInputWrapper.classList.remove(HIDDEN)
        }

        toggleRejectionNotesVisibility()
    }

    const toggleRejectionNotesVisibility = () => {
        const selectedRejectionReason = rejectionReasonInputWrapper.querySelector(REJECTION_REASON_CHECKED)
        const RejectionNotesInput = RejectionNotesInputWrapper.querySelector("textarea")

        if (!selectedRejectionReason) {
            RejectionNotesInputWrapper.classList.add(HIDDEN)
            RejectionNotesInput.disabled = true

            return
        }

        RejectionNotesInputWrapper.classList.remove(HIDDEN)
        RejectionNotesInput.disabled = false

        RejectionNotesInput.required = selectedRejectionReason.value === REJECTION_REASON_OTHER
    }

    const addEventListeners = () => {
        // Attach event listener to the parent (event delegation)
        decisionInputWrapper?.addEventListener("change", toggleRejectionReasonVisibility)
        rejectionReasonInputWrapper.addEventListener("change", toggleRejectionNotesVisibility)
    }

    const addFormEventListener = () => {
        container.addEventListener("submit", (e) => {
            const selectedRejectionReason = rejectionReasonInputWrapper.querySelector(REJECTION_REASON_CHECKED)
            if (!selectedRejectionReason || selectedRejectionReason.value !== REJECTION_REASON_OTHER)
                RejectionNotesInputWrapper.remove()

            if (!decisionInputWrapper) return

            const selectedDecision = decisionInputWrapper.querySelector(DECISION_CHECKED)
            if (!selectedDecision || selectedDecision.value !== DECISION_REJECTION)
                rejectionReasonInputWrapper.remove()
        })
    }

    // Initialize state on page load
    toggleRejectionReasonVisibility()
    toggleRejectionNotesVisibility()

    addEventListeners()
    addFormEventListener()
})
